import { cn } from 'src/lib/utils'
import { ChatFilled } from 'src/shared/components/icons/chat/chat-filled'
import { Button } from 'src/shared/components/ui/buttons/button'
import { Dialog, DialogContent } from 'src/shared/components/ui/popups/dialog'
import { OverlappedUsers } from 'src/shared/features/users/components/overlapped-users'
import { type PublicUserData, type PrivateUserData } from 'src/shared/features/users/schemas/user'
import { useIsMobile } from 'src/shared/hooks/use-mobile'

interface ConfirmSneakDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  currentUser: PrivateUserData | undefined
  targetUser: PublicUserData | undefined
  isLoading: boolean
  onConfirm: () => void
}

export const ConfirmSneakDialog = ({
  open,
  onOpenChange,
  currentUser,
  targetUser,
  isLoading,
  onConfirm,
}: ConfirmSneakDialogProps) => {
  const isMobile = useIsMobile()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn('bg-primary text-white', isMobile ? 'w-full max-w-[85vw] rounded-lg p-6' : 'max-w-sm p-8')}
        dark
      >
        <div className="flex flex-col items-center gap-8 md:gap-12">
          <h2 className="text-center text-2xl font-semibold md:text-3xl">Message {targetUser?.firstName || 'User'}</h2>

          <OverlappedUsers
            firstUserPhoto={currentUser?.profilePhoto}
            secondUserPhoto={targetUser?.profilePhoto}
            icon={ChatFilled}
            centerColor="bg-sneak"
            size={isMobile ? 'lg' : 'xl'}
          />

          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={onConfirm}
              disabled={isLoading}
              className="w-full rounded-lg bg-sneak py-2.5 text-base font-semibold text-white hover:bg-sneak/90"
            >
              {isLoading ? 'Creating chat...' : 'Use sneak credit'}
            </Button>

            <p className="text-center text-sm text-white/70">
              {currentUser?.subscription?.sneakCredits || 0} credits available
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
